<template lang="pug">
  // set id for ssr reasons
  div(id="app")
    router-view(:class="`region-${currentRegionName} module-${currentModule} page-${currentPage}`")
</template>

<script>
  import region from '../../utils/region.js'
  import {DEFAULT_REDIRECT} from "../../config/config"
  import url from '../../utils/url'

  export default {
    computed: {
      currentRegionName() {
        return region.getCurrentRegion()
      },
      currentModule() {
        if (!this.$route.name) {
          return 'null'
        }
        return this.$route.name.split('.')[0]
      },
      currentPage() {
        if (!this.$route.name) {
          return 'null'
        }
        let names = this.$route.name.split('.')
        names.shift()
        return names.join('-')
      },
      needReLogin() {
        return this.$store.getters.needReLogin
      }
    },
    watch: {
      'needReLogin': 'onNeedReLogin'
    },
    created() {
      console.log('Welcome to App', APP_FULL_VERSION, APP_LAST_BUILD)
      // after app created, update user data
      // server update at work incorrect
      this.$store.dispatch('updateUserData')
    },
    mounted() {
      this.removeBootstrapError()
    },
    methods: {
      removeBootstrapError() {
        let el = document.getElementById('bootstrap-error')
        if (el) {
          el.parentNode.removeChild(el)
        }
      },
      onNeedReLogin(val) {
        if (val && val.value === true) {
          this.$store.commit('needReLogin', false)
          this.$store.commit('userDelAuthData')
          if (this.$route.name !== 'auth.login') {
            const redirectUrl = this.$router.history.pending
              ? url.getRoute(this.$router.history.pending)
              : url.getRoute(this.$route)
            this.$store.commit('userSetRedirectUrl', redirectUrl)
            console.log('redirectUrl', redirectUrl)
            this.$router.push(DEFAULT_REDIRECT.default, () => {
              this.$store.commit('mutateError', null)
            })
          } else {
            this.$store.commit('mutateError', null)
          }
        }
      }
    }
  }
</script>
